import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Drawer, Flex } from 'antd';
import React from 'react';
import { useConversation } from '~/hooks/useConversations';

import ConversationView from './ConversationView';

function DrawerTitle({ conversationId, onBack }) {
  const { data: conversation } = useConversation(conversationId);
  const clientName = conversation?.user?.deleted ? 'Utilisateur supprimé' : `${conversation?.user?.first_name || ''} ${conversation?.user?.last_name || ''}`;

  return (
    <Flex align='center' gap={12}>
      <Button type='text' className='btn-icon btn-dark' icon={<ArrowLeftOutlined />} onClick={onBack} />
      <p className='sub1'>{clientName}</p>
    </Flex>
  );
}

function ConversationMobileDrawer({ selectedConversation, setSelectedConversation, activeMerchantId, onStatusChange }) {
  return (
    <Drawer
      open={!!selectedConversation}
      placement='right'
      width='100%'
      closable={false}
      title={selectedConversation ? <DrawerTitle conversationId={selectedConversation} onBack={() => setSelectedConversation(null)} /> : null}
      styles={{ body: { padding: 0 } }}
    >
      {selectedConversation && <ConversationView conversationId={selectedConversation} activeMerchantId={activeMerchantId} onStatusChange={onStatusChange} />}
    </Drawer>
  );
}

export default ConversationMobileDrawer;
